module.exports = __webpack_public_path__ + "img/giphy8.7692eb9e.gif";